export default {
    showing: "Exibindo {0}-{1} de {2}",
    items_per_page: "Itens por página:",
    go_to: "Ir para:",
};
